import { CheckIcon, ChevronRightIcon } from '@radix-ui/react-icons';

import { useThemeContext } from '../../../../contexts/ThemeContext';
import { resolveColor } from '../../theme/utils/resolveColor';
import { PoweredByQITech } from '../components/PoweredByQITech';
import { Contacts } from '../components/Contacts';
import { normalizeLineBreaks } from '../../../../utils/utils';
import { useCallbackRedirect } from '../../../../utils/hooks/useCallbackRedirect';
import * as S from './styles';

interface SignedPageProps {
    signData: any;
}

export const SocialSecuritySignedPage = ({ signData }: SignedPageProps) => {
    const { clientThemeSettings } = useThemeContext();
    const primary = resolveColor('primary', clientThemeSettings);
    const text = resolveColor('text', clientThemeSettings)

    const callbackUrl = signData?.signer_data?.callback_url;
    const completeSignatureContent = signData.signature_settings?.complete_signature_content;

    const { countdown, redirectToCallback } = useCallbackRedirect(
        callbackUrl,
        signData?.signer_data?.callback_redirection_seconds,
    );

    return (
        <S.PageWrapper>
            <S.LogoSection>
                {clientThemeSettings?.logo_url && (
                    <S.LogoImage src={clientThemeSettings.logo_url} alt="logo" />
                )}
            </S.LogoSection>

            <S.Content>
                <S.CheckCircle $color={primary}>
                    <CheckIcon width={48} height={48} color={primary} />
                </S.CheckCircle>

                <S.Title $text={text}>
                    {completeSignatureContent?.title ?? 'Recebemos sua proposta e já estamos analisando'}
                </S.Title>

                <S.Subtitle>
                    {normalizeLineBreaks(completeSignatureContent?.raw_text) ?? 'Se for aprovada, o valor será depositado direto na sua conta.'}
                </S.Subtitle>
            </S.Content>

            <S.Separator />

            {(completeSignatureContent?.contacts ?? []).length > 0 && (
                <Contacts contacts={completeSignatureContent.contacts} />
            )}

            {!!callbackUrl && (
                <S.CallbackSection>
                    <S.CallbackText>
                        Para dúvidas e acompanhamento da proposta acesse{' '}
                            <S.CallbackLink href={callbackUrl} $color={primary} target="_blank" rel="noopener noreferrer">
                                {callbackUrl}
                            </S.CallbackLink>
                            .
                    </S.CallbackText>
                    <S.Button $backgroundColor={primary} $disabled={false} onClick={redirectToCallback}>
                        Ir ao acompanhamento
                        <ChevronRightIcon width={18} height={18} />
                    </S.Button>
                    {countdown !== null && (
                        <S.CountdownText>
                            Você será redirecionado automaticamente em {countdown}s
                        </S.CountdownText>
                    )}
                </S.CallbackSection>
            )}
            <S.Footer>
                <PoweredByQITech />
            </S.Footer>
        </S.PageWrapper>
    );
};
